import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/wx.png'
import _imports_1 from '../assets/zfb.png'
import _imports_2 from '../assets/kfIcon.png'


const _withScopeId = n => (_pushScopeId("data-v-2741c121"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#333333"} }, "还没有收货地址，去添加一个吧", -1))
const _hoisted_5 = { class: "nameOrphone" }
const _hoisted_6 = { class: "address" }
const _hoisted_7 = {
  key: 1,
  class: "other"
}
const _hoisted_8 = {
  class: "otherField",
  style: {"align-items":"center","margin-bottom":"0"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label",
  style: {"width":"90px"}
}, "卡板编码", -1))
const _hoisted_10 = { class: "product-container" }
const _hoisted_11 = { class: "name" }
const _hoisted_12 = { class: "tag" }
const _hoisted_13 = { class: "select" }
const _hoisted_14 = { class: "price" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"0.24rem"} }, "￥", -1))
const _hoisted_16 = { class: "quantity" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 购买数量 ")
const _hoisted_18 = { class: "other" }
const _hoisted_19 = { class: "otherField" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "配送方式", -1))
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { class: "otherField" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "支付方式", -1))
const _hoisted_24 = { class: "value" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  key: 1,
  src: _imports_0,
  style: {"height":"0.32rem","margin-right":"0.05rem"},
  alt: ""
}
const _hoisted_27 = { class: "order-notes" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "订单备注", -1))
const _hoisted_29 = { class: "payContent" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pTitle" }, "请选择支付方式", -1))
const _hoisted_31 = { class: "payList" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_34 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_35 = { class: "payContent" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pTitle" }, "请选择配送方式", -1))
const _hoisted_37 = /*#__PURE__*/_createTextVNode("普通快递包邮 ")
const _hoisted_38 = { class: "footer" }
const _hoisted_39 = { class: "footContent" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "kfIcon",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" 客服 ")
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = { class: "flex" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" 合计: ")
const _hoisted_45 = { class: "price" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"0.24rem"} }, "￥", -1))
const _hoisted_47 = /*#__PURE__*/_createTextVNode("立即购买")

import {
  NavBar,
  Icon,
  Divider,
  Stepper,
  Field,
  Popup,
  Dialog,
  Button,
  Tabs,
  Tab,
  Toast,
  RadioGroup,
  Radio,
} from "vant";
import router from "@/router";
import { Decimal } from "decimal.js";
import { computed, onMounted, ref, inject } from "vue";
import { useRoute } from "vue-router";
import AddAddress from "./Address.vue";
import {
  LxsAllChannel,
  LxsFxAllChannel,
  LxsTSAllChannel,
  LxsTSAllChannel1,
} from "@/utils/constants";
import pingpp from "pingpp-js";
import Request, { request } from "@/provide/fetch";
import { getChannelCodeFromCache } from "@/utils/channelCode";

export default /*#__PURE__*/_defineComponent({
  name: 'submitOrder',
  setup(__props) {

const route = useRoute();
const goodeId = route.query.id;
const activeFlowType = route.query.activeFlowType;
const activeFlowGear = route.query.activeFlowGear;
const activeFate = route.query.activeFate;
const supplierName = route.query.supplierName;
const userIP = ref("");
const quantity = ref(1);
const snNumber = ref("");
const tabList = ref([
  {
    name: "购买卡板+套餐",
    value: "购买卡板+套餐",
  },
  {
    name: "仅充值套餐(有卡板)",
    value: "仅充值套餐(有卡板)",
  },
]);
const activeTab = ref(0);
const channelCode = ref<any>(getChannelCodeFromCache());
onMounted(async () => {
  const res = await fetch("https://ip.liulv.net/ip");
  const data = await res.json();
  userIP.value = data.ip;
});
const goodvalue = ref({});
request({
  url: `/product/get-child-product`,
  method: "POST",
  data: {
    flowLevel: activeFlowGear,
    selectDays: activeFate,
    flowType: activeFlowType,
    productId: Number(goodeId),
  },
})
  .then((res) => {
    goodvalue.value = res.data;
  })
  .catch(() => {
    Toast("网络错误，请稍后重试");
  });
const payType = ref("wx");
const copyPayType = ref("wx");
const payTypeList = ref(["wx", "zfb"]);
const remarks = ref("");
const payTypeShow = ref(false);
const total = computed(() => {
  return (quantity.value * oneProductPrice.value || 0).toFixed(2);
});
const addressShow = ref(false);
const saveLoading = ref(false);
// 中移产品，购买卡板+套餐是1，卓一产品购买卡板+套餐是3，仅充值套餐(有卡板)订单都是2
const orderOperatorType = computed(() => {
  if (activeTab.value == 0) {
    // supplierName === "卓一" ? 3 : 1;
    return 1;
  } else {
    return 2;
  }
});
// /card-order/pay
const handleSubmit = () => {
  // 保存订单
  let aid = null;
  if (activeTab.value == 0) {
    if (!addressObject.value?.addressId) {
      return Toast("请选择收货地址");
    }
    aid = addressObject.value.addressId;
  } else {
    if (!snNumber.value) return Toast("请填写SN号");
    if (snNumber.value.length < 20) return Toast("请输入卡板上的20位SN号");
  }
  const payValue = {
    wx: 1,
    zfb: 2,
    xj: 3,
  };
  saveLoading.value = true;
  console.log(new Decimal(total.value * 100), "总金额");
  const num = new Decimal(total.value);
  const preciseResult = num.mul(10000).div(100); // 链式调用：先乘后除
  Request({
    url: "/order/save",
    method: "POST",
    data: {
      addressId: aid,
      sn: snNumber.value,
      productCode: goodvalue.value?.childProductCode,
      buyCount: quantity.value,
      deliveryType: deliveryType.value,
      payType: payValue[payType.value],
      payPrice: preciseResult.toNumber(),
      orderComment: remarks.value,
      channelCode: channelCode.value,
      orderOperatorType: orderOperatorType.value,
    },
  })
    .then((resp: any) => {
      if (resp.code === 200) {
        saveLoading.value = true;
        const data = {
          orderId: resp.data,
          payType: payValue[payType.value],
          price: preciseResult.toNumber(),
          clientIp: userIP.value,
          channel: channelCode.value,
          openId: localStorage.getItem("bjopenid"),
          wayCode: payType.value == "xj" ? "OFFLINE_CASH" : "WX_JSAPI",
        };
        Request({
          url: "/bj-pay/pay",
          method: "POST",
          data: data,
        })
          .then((res) => {
            if (payType.value == "xj") {
              router.push({
                path: "/OrderPage",
                query: {
                  status: "已完成"
                }
              });
            } else {
              const data = JSON.parse(res.data.payData);
              const mchOrderNo = res.data.mchOrderNo;
              console.log(data, data.appId, mchOrderNo, "返回的数据");
              wx.chooseWXPay({
                timestamp: data.timeStamp,
                nonceStr: data.nonceStr,
                package: data.package,
                signType: data.signType,
                paySign: data.paySign,
                appId: "wx5560a79be8783f5d",
                success: function (res1: any) {
                  console.log(res1, "成功");
                  router.push({
                    path: "/SuccessPay",
                    query: { payNo: mchOrderNo },
                  });
                },
                complete: (res: any) => {
                  console.log("complete");
                  console.log(res.errMsg);
                  console.log(res);
                  if (res.errMsg === "chooseWXPay:cancel") {
                    router.push({
                      path: "/OrderPage",
                    });
                  }
                },
              });
            }
          })
          .finally(() => {
            saveLoading.value = false;
          });
      } else {
        Toast(resp.message);
      }
    })
    .finally(() => {
      saveLoading.value = false;
    });
};
// 客服
const kfshow = ref(false);
const handleKfConfirm = () => {
  // kfshow.value = false;
  window.location.href = "tel:010-63589500";
};
const handleShowCustomerService = inject(
  "handleShowCustomerService"
) as () => void;
const handleKf = () => {
  handleShowCustomerService();
};
const handleChangeAddress = (value: any) => {
  addressShow.value = false;
};
const addressObject = ref({});
const handleSelectAddress = (value: any) => {
  addressShow.value = false;
  addressObject.value = value;
  isShowAdress.value = true;
};
const isShowAdress = ref(false);
const handleGetDefaultAddress = async () => {
  const res = await request({
    url: "/order/address/page",
    method: "POST",
    data: {
      searchOption: {
        isDefault: 1,
      },
      pageParam: { current: 1, size: 100 },
    },
  });
  if (res.code === 200) {
    addressObject.value = res.data.records[0];
    isShowAdress.value = res.data.records.length > 0;
  }
};
handleGetDefaultAddress();
const deliveryType = ref<any>("1");
const copyDeliveryType = ref("1");
const deliveryTypeShow = ref(false);
const oneProductPrice = computed(() => {
  if (goodvalue.value) {
    return activeTab.value == 0
      ? goodvalue.value?.productPrice
      : goodvalue.value?.rechargePrice;
  }
  return 0;
});
// 北京营业厅
if (channelCode.value == "BjqyBjqyYyt") {
  activeTab.value = 1;
  deliveryType.value = "2";
}
//
if (LxsFxAllChannel.includes(channelCode.value)) {
  activeTab.value = 1;
  deliveryType.value = "1";
  payType.value = "xj";
}

if (LxsTSAllChannel.includes(channelCode.value)) {
  activeTab.value = 1;
}

// if (LxsTSAllChannel1.includes(channelCode.value)) {
//   activeTab.value = 0;
// }
const handleTabChange = () => {
  quantity.value = 1;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NavBar), {
      title: "确认订单",
      "left-arrow": "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1)))
    }),
    (channelCode.value === 'BjqyBjqyPt' || _unref(LxsAllChannel).includes(channelCode.value))
      ? (_openBlock(), _createBlock(_unref(Tabs), {
          key: 0,
          active: activeTab.value,
          "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => ((activeTab).value = $event)),
          color: "#386bf6",
          onClick: handleTabChange
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item, index) => {
              return (_openBlock(), _createBlock(_unref(Tab), {
                title: item.name,
                key: index
              }, null, 8, ["title"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["active"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (activeTab.value == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (!isShowAdress.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "address-container",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (addressShow.value = true))
                }, [
                  _hoisted_4,
                  _createVNode(_unref(Icon), { name: "arrow" })
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (addressShow.value = true)),
                  class: "address-container"
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("span", null, _toDisplayString(addressObject.value.userName), 1),
                      _createElementVNode("span", null, _toDisplayString(addressObject.value.phone), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(addressObject.value.province) + " " + _toDisplayString(addressObject.value.city) + " " + _toDisplayString(addressObject.value.country) + " " + _toDisplayString(addressObject.value.detailAddress), 1)
                  ]),
                  _createVNode(_unref(Icon), { name: "arrow" })
                ]))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_unref(Field), {
                class: "value",
                modelValue: snNumber.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((snNumber).value = $event)),
                label: ``,
                name: "snNumber",
                type: "tel",
                maxlength: "20",
                placeholder: "请输入卡板上的20位卡板编码",
                rules: [{ required: true, message: '请输入卡板上的20位卡板编码' }]
              }, null, 8, ["modelValue"])
            ])
          ])),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, _toDisplayString(goodvalue.value.productName), 1),
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goodvalue.value.productSellPoints, (item) => {
            return (_openBlock(), _createElementBlock("span", {
              key: item,
              class: "tagItem"
            }, _toDisplayString(item), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(activeFlowGear)) + " × " + _toDisplayString(_unref(activeFate)), 1),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createTextVNode(" " + _toDisplayString(_unref(oneProductPrice)), 1)
        ]),
        _createVNode(_unref(Divider), { style: {"margin":"0.12rem 0"} }),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode(_unref(Stepper), {
            disabled: !(_unref(LxsAllChannel).includes(channelCode.value) && activeTab.value == 0),
            modelValue: quantity.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((quantity).value = $event)),
            min: 1,
            max: 99
          }, null, 8, ["disabled", "modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("span", _hoisted_21, _toDisplayString(deliveryType.value == "1" ? "普通快递包邮" : "线下自提"), 1)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("span", _hoisted_24, [
            (payType.value == 'xj')
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, "现金支付"))
              : _createCommentVNode("", true),
            (payType.value == 'wx')
              ? (_openBlock(), _createElementBlock("img", _hoisted_26))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createVNode(_unref(Field), {
            class: "textarea",
            placeholder: "如有备注请填写",
            modelValue: remarks.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((remarks).value = $event)),
            rows: "2",
            type: "textarea"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createVNode(_unref(Popup), {
        show: addressShow.value,
        "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((addressShow).value = $event)),
        position: "right",
        style: { width: '100%', height: '100%' }
      }, {
        default: _withCtx(() => [
          _createVNode(AddAddress, {
            type: "submitOrder",
            onChange: handleChangeAddress,
            onSelect: handleSelectAddress
          })
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(_unref(Popup), {
        show: payTypeShow.value,
        "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => ((payTypeShow).value = $event)),
        round: "",
        position: "bottom",
        style: { height: '30%' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payTypeList.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item,
                  class: _normalizeClass(["payItem", { activePay: item === copyPayType.value }]),
                  onClick: ($event: any) => (copyPayType.value = item)
                }, [
                  (item === 'wx')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_33))
                    : _createCommentVNode("", true),
                  (item === 'zfb')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_34))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_32))
              }), 128))
            ]),
            _createElementVNode("div", {
              class: "payBtn",
              onClick: _cache[8] || (_cache[8] = ($event: any) => ((payTypeShow.value = false), (payType.value = copyPayType.value)))
            }, " 确认 ")
          ])
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(_unref(Popup), {
        show: deliveryTypeShow.value,
        "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => ((deliveryTypeShow).value = $event)),
        round: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("div", null, [
              _createVNode(_unref(RadioGroup), {
                modelValue: copyDeliveryType.value,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((copyDeliveryType).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Radio), {
                    name: "1",
                    style: {"margin-bottom":"0.3rem","margin-top":"1rem","font-size":"0.35rem"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_37
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", {
              class: "payBtn",
              style: {"margin-top":"1rem"},
              onClick: _cache[11] || (_cache[11] = ($event: any) => (
              (deliveryTypeShow.value = false), (deliveryType.value = copyDeliveryType.value)
            ))
            }, " 确认 ")
          ])
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", {
          class: "kf",
          onClick: handleKf
        }, _hoisted_42),
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _createElementVNode("div", _hoisted_45, [
            _hoisted_46,
            _createTextVNode(_toDisplayString(_unref(total)), 1)
          ])
        ]),
        _createVNode(_unref(Button), {
          loading: saveLoading.value,
          class: "submitBtn",
          onClick: handleSubmit
        }, {
          default: _withCtx(() => [
            _hoisted_47
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ])
  ]))
}
}

})